import "./WordCard.css";

const WordCard = ({word}) => {

  return (
    <div className="lavender-container">
      <p className="word">{word}</p>
    </div>
  )
};

export { WordCard };